import { Controller } from '@hotwired/stimulus'

// Connects to data-controller='user-settings'
export default class extends Controller {
  connect() {
    const element = $(this.element);
    const dateFormat = element.data('dateFormat');

    const userBrowserLocale = dateFormat || navigator.language || 'en-gb';
    moment.locale(userBrowserLocale.toLowerCase());

    window.serverSideDateFormat = 'DD.MM.YYYY';
    window.userPreferenceDateFormat = moment.localeData().longDateFormat('L');
  }
}
